import gql from 'graphql-tag';

const AccountMetadata_Fragment = gql`
  fragment AccountMetadata_Fragment on AccountMetadata {
    setup {
      completed
    }
  }
`;

export default gql`
  fragment AccountSettingsFields on AccountSettings {
    logo {
      s3key
      url
    }
    colors {
      primary {
        background
        color
      }
      secondary {
        background
        color
      }
    }
    url
    metadata {
      ...AccountMetadata_Fragment
    }
  }

  ${AccountMetadata_Fragment}
`;
